import {EMAIL_MAKER_COMMANDS, EMAIL_MAKER_COMPONENT_TYPES, EMAIL_MAKER_PROPS} from '@EmailMakerReact/email-maker-react.constants';
import type {Component, ComponentModelDefinition} from 'grapesjs';
import type {ComponentRegistrationContext} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/helpers/component-helpers';
import {defaultViewEvents, matchByTagAndAttr} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/helpers/component-helpers';

export function registerSocialTypes({
  editor,
  defaultToolbarOptions,
  unstylableEmailStyles,
  dispatchDblClickOnDoubleTap,
  initRemovalOfUnsupportedCssProperties,
}: ComponentRegistrationContext): void {
  const cmpt = editor.Components;
  cmpt.addType(EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS, {
    model: {
      defaults: {
        trackingName: 'Socials',
        toolbar: defaultToolbarOptions,
        draggable: true,
        hoverable: true,
        selectable: true,
        highlightable: false,
        droppable: false,
        name: window.i18next.t('pmwjs_social'),
        badgable: true,
        unstylable: unstylableEmailStyles,
        [EMAIL_MAKER_PROPS.HAS_BORDER_CONTROLS]: true,
        attributes: {
          'data-is-pmw-socials': '1',
          'data-pmw-type': EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS,
        },
        style: {
          display: 'block',
          margin: '0',
          width: 'unset',
          'min-height': 'fit-content',
          padding: '8px',
          'text-align': 'center',
          'border-color': '#FFFFFF',
          'border-width': '0px',
          'border-style': 'none',
        },
      },
      init(this: ComponentModelDefinition & Component) {
        initRemovalOfUnsupportedCssProperties(this);
        this.on('change:style:width', () => {
          if (this.getStyle().width === '100%') {
            editor.runCommand(EMAIL_MAKER_COMMANDS.FIX_COMPONENT_FULL_WIDTH_OVERFLOW_AOL_YAHOO);
          }
        });
      },
    },
    view: {
      events: defaultViewEvents(dispatchDblClickOnDoubleTap),
    },
    isComponent: matchByTagAndAttr('DIV', 'data-is-pmw-socials', EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS),
  });

  cmpt.addType(EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS_ITEM, {
    model: {
      defaults: {
        trackingName: null,
        name: window.i18next.t('pmwjs_social_link'),
        toolbar: [],
        removable: false,
        selectable: false,
        hoverable: false,
        highlightable: false,
        badgable: false,
        draggable: false,
        droppable: false,
        unstylable: unstylableEmailStyles,
        [EMAIL_MAKER_PROPS.HAS_BORDER_CONTROLS]: false,
        attributes: {
          'data-is-pmw-social-item': '1',
          'data-pmw-type': EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS_ITEM,
        },
        style: {
          margin: '5px',
          'text-decoration': 'none',
          display: 'inline-block',
        },
      },
      init(this: ComponentModelDefinition & Component) {
        initRemovalOfUnsupportedCssProperties(this);
      },
    },
    view: {
      events: defaultViewEvents(dispatchDblClickOnDoubleTap),
    },
    isComponent: matchByTagAndAttr('A', 'data-is-pmw-social-item', EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS_ITEM),
  });

  cmpt.addType(EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS_IMAGE, {
    extend: EMAIL_MAKER_COMPONENT_TYPES.default.IMAGE,
    model: {
      defaults: {
        trackingName: null,
        toolbar: [],
        removable: false,
        selectable: false,
        highlightable: false,
        hoverable: false,
        resizable: false,
        badgable: false,
        draggable: false,
        droppable: false,
        editable: false,
        unstylable: unstylableEmailStyles,
        [EMAIL_MAKER_PROPS.HAS_BORDER_CONTROLS]: false,
        attributes: {
          'data-is-pmw-social-image': '1',
          'data-pmw-type': EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS_IMAGE,
          alt: '',
        },
        style: {
          width: '38px',
          height: '38px',
          display: 'inline-block',
        },
      },
      init(this: ComponentModelDefinition & Component) {
        initRemovalOfUnsupportedCssProperties(this);
      },
    },
    view: {
      events: defaultViewEvents(dispatchDblClickOnDoubleTap),
    },
    isComponent: matchByTagAndAttr('IMG', 'data-is-pmw-social-image', EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS_IMAGE),
  });
}
